import React from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import {
    isSet,
    getSelectedValueBasedOnField,
    convertStrToArrWithSeparator
} from '../../Utils/CommonFunctions';
import {API_URL} from '../../Global/Constants';

import SubformTypeForm from '../../Containers/LayoutContainer/LayoutForms/SubformTypeForm';
import SectionTypeForm from '../../Containers/LayoutContainer/LayoutForms/SectionTypeForm';
import jQuery from "jquery";
import SwitchItems from '../../Components/FormBuilder/Builder/FormInputs/SwitchItems';
import FormInputFields from '../FormInputFields';
import { ErrorBlock } from '../../hoc/FormInput';

  //EXTRACT STYLES TAG CSS 
  export const extractStylesAsObjects = str => {
    const style = {};
    str.split(";").forEach(el => {
      if(el.toString().trim()!==''){
        const [property, value] = el.split(":");
        if (!property) return;
    
        const formattedProperty = formatStringToCamelCase(property.trim());
        style[formattedProperty] = value.toString().trim();
      }
    });
    return style;
  }
    //Format XML Value to Pretty formatted
    export const convertToPrettyXml = (xml)=>
    {
      var formatted = '';
      var reg = /(>)(<)(\/*)/g;
      xml = xml.replace(reg, '$1\r\n$2$3');
      var pad = 0;
      jQuery.each(xml.split('\r\n'), function(index, node) {
          var indent = 0;
          if (node.match( /.+<\/\w[^>]*>$/ )) {
              indent = 0;
          } else if (node.match( /^<\/\w/ )) {
              if (pad != 0) {
                  pad -= 1;
              }
          } else if (node.match( /^<\w[^>]*[^\/]>.*$/ )) {
              indent = 1;
          } else {
              indent = 0;
          }
          var padding = '';
          for (var i = 0; i < pad; i++) {
              padding += '  ';
          }
          formatted += padding + node + '\r\n';
          pad += indent;
      });
      return formatted;
  }


  //FORMAT  HYPEN FORMAT PROPERTIES STYLES TO CAMELCASE
  export const formatStringToCamelCase = str => {
    const splitted = str.split("-");
    if (splitted.length === 1) return splitted[0];
    return (
      splitted[0] +
      splitted
        .slice(1)
        .map(word => word[0].toUpperCase() + word.slice(1))
        .join("")
    );
  }

  

export const extractFieldValue = (dynamicVar,entries)=>{
  let returnValue = null;
  const replace = entries.replace(/("|')/g, "").replace(/\[([^\]]+)\]/g, '.$1');
  // dot or sq brackets to dot
  const entriesInArr = convertStrToArrWithSeparator(replace,'.');
  //split with dot seprator

  // Object.entries(dynamicVar).map(([key, value]) => {
    // stg = stg.replace(key,'dynamicVar["'+key+'"]');
  // });
  // dots.replace(/\.(.+?)(?=\.|$)/g, (m, s) => `[${s}]`)
  let updatedEntriesInArr = [];
  entriesInArr.map((ent)=>{
    if(Object.keys(dynamicVar).indexOf(ent)!==-1){
      updatedEntriesInArr.push('dynamicVar["'+ent+'"]');
    }else{
      updatedEntriesInArr.push('"'+ent+'"');
    }
  })
  // console.log('entriesInArr',entriesInArr,updatedEntriesInArr);
  const entriesBackToStr = updatedEntriesInArr.join('.');
  const finalStr = entriesBackToStr.replace(/\.(.+?)(?=\.|$)/g, (m, s) => `[${s}]`);
  // console.log('finalStr12',finalStr,dynamicVar);
  try{
    if(finalStr.indexOf('dynamicVar')!==-1){
      returnValue = eval(finalStr)
    }
  }catch(e){

  }
  // console.log('extractFieldValue',entries,finalStr,returnValue,dynamicVar);
  return returnValue;
  
}
 
  //GET FIELDS PROPS ELEMENT
  export const getFieldsPropsElement = (attributes,paramObj)=>{
    const {type,defProps} = paramObj;
    let attribsName = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
    const {modType,fieldGroups,formFields} = defProps;
    let element = null;
    fieldGroups.map((section) => {
        if(section.type!=='subform'){
            section.data.map((field,itemIndex)=>{
                if(field.label.blocks[0].text.toLowerCase()===attribsName.toLowerCase()){ 
                  const fieldObj = {
                    section_index:section.section_index,
                    itemIndex:field.itemIndex,
                    modType:modType,
                    item:{
                     ...field,
                    
                     modType:modType
                   },
                 }
                    let appendAttr ={};
                    if(isSet(attributes.class,'')!==''){
                      appendAttr = {
                        className:isSet(attributes.class,'')
                      }
                    }
                    console.log()
                    element =  <SwitchItems 
                                  {...defProps} 
                                  key={itemIndex}
                                  fieldObj={fieldObj}
                                  item={{...field,displayType:isSet(attributes.displaytype,''),customAttr:isSet(attributes,''),modType:modType}}
                                  inputBlockOnly={true}
                                  {...appendAttr}
                                  onlyInputComponent={true}
                                  errorBlock={true}
                                  isLabel={isSet(attributes.withlabel,true) === 'false' ? false : Boolean(isSet(attributes.withlabel,true))}
                                  withoutBlock={isSet(attributes.inputOnly,true) === 'false' ? false : Boolean(isSet(attributes.inputOnly,true))}
                                  section={section} />
                    
                }
            }) 
        }
      });
    const indexing = formFields.findIndex((i)=>attribsName.toLowerCase()===i.label.toLowerCase());
    if(indexing!==-1){
      element = <>
      
                <FormInputFields {...formFields[indexing]} />
                <ErrorBlock message={isSet(formFields[indexing].error,'')}/>    
                </>
    }
    // console.log('formFields',formFields,indexing);
    return element;  
  }


  export const getFieldsPropsSection = (attributes,paramObj)=>{
    let attribsName = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
    const {type,defProps} = paramObj;
    const {modType,fieldGroups} = defProps;
    
    let element = null;
    fieldGroups.map((section,index) => {
      const FormTypeComp =  (section.type==='subform')?SubformTypeForm:SectionTypeForm; 
      if((section.access_mode==undefined || section.access_mode!=='HIDDEN') && (section.title.toLowerCase()===attribsName.toLowerCase())){
        element = <Wrp key={index}>
                  <FormTypeComp 
                    {...defProps}
                    section={JSON.stringify(section)}
                    column_type={section.column_type}
                    sectionIndex={index}
                    modType={modType}
                    isPopupWindow={false}
                    // windowDetails={props.windowDetails}
                    // onChangeInputAction={props.onChangeInputAction}
                    // DVauditLog={props.DVauditLog}
                    // reminderDisplayText={reminderDisplayText}
                    // isQuickCreate={props.isQuickCreate}
                    // validationForms={props.validationForms}
                    pageType={'form'} 
                    // {...defProps}
                  />
                    </Wrp>
        
        // element = <Wrp>
        //           <div className="col-12 mb-2">
        //           <div className="card-outer">
        //           <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
        //             <div className={`card-title d-flex align-items-center justify-content-between`} id={'card'+section.id} data-toggle="collapse" href={`#${section.id}`}>   
        //               <h6 className="mb-0"> {section.title} </h6>
        //               <div className="span-mode"></div>
        //             </div>
        //           </div>
        //           <div className={`form-body pt-2 p-2 show`} id={section.id}>
        //             <div className="row" key={"forms"+index}>
        //               {section.data.map((field,itemIndex)=>{
        //                 const fieldObj = {
        //                   section_index:section.section_index,
        //                   itemIndex:field.itemIndex,
        //                   modType:modType,
        //                   item:{
        //                    ...field,
        //                    modType:modType
        //                  },
        //                }
        //                 return <SwitchItems
        //                           key={itemIndex}
        //                           item={{...field,modType:modType}}
        //                           fieldObj={fieldObj} 
        //                           // inputBlockOnly={true}
        //                           section={section}
        //                           {...defProps} 
        //                         />
        //                 }) }
        //             </div>
        //           </div>
        //           </div>
        //           </div>
        //         </Wrp>
      }
    })
  return element;  
}
export const getAttribute = (attributes,name,def='')=>{
  return (attributes.hasOwnProperty(name)===true)?attributes[name]:def;
}
export const isAttrHasProperty = (attributes,name)=>{
  return attributes.hasOwnProperty(name);
}

export const formatVal = (attribs,value)=>{
  if(isAttrHasProperty(attribs,'precision') && value !== null){
      return Number(value).toFixed(getAttribute(attribs,'precision'));
  }
  return value;
}

export const getOutputFieldsElement = (attributes,paramObj)=>{
  const {loopData,defProps,dataTable,dynamicVar} = paramObj;
  const {fieldGroups,formFields} = defProps;
    let element =null;
    let attribsName   = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
    let fieldType     = (attributes.hasOwnProperty('type')===true)?attributes.type:'';
    let attribsValue  = (attributes.hasOwnProperty('value')===true)?attributes.value:'';
    let defaultValue  = (attributes.hasOwnProperty('defaultvalue')===true)?attributes.defaultvalue:'';
    const value       = isSet(attribsName,attribsValue);

      if(isSet(extractFieldValue(dynamicVar,value),null)!==null){ 
        element = isSet(extractFieldValue(dynamicVar,value),isSet(defaultValue,''));
        // console.log('formatVal',formatVal(attributes,element),element);
        // console.log('text - key',value,attributes,loopData);
        
          if(isSet(fieldType,'')==='image'){
            let imgUrl = API_URL+'files/download?fileId='+element;
            if(isSet(attributes.isexternal,'false')==='true'){
              imgUrl = element;
            }
            element = React.createElement('img', {src:imgUrl,...attributes,style:{width:'100%',minWidth:'100px',maxWidth:'100px',overflow:'hidden'}})
          }else{
            element = formatVal(attributes,element);
          }
      }else{
        Object.entries(isSet(loopData,{})).map(([key, Data]) => {
          const dataTableName =  isSet(dataTable,'').toLowerCase()+'.';
          const replacingParent = value.toLowerCase().replace(dataTableName, "");
          // console.log('Image - key',key,value,attributes);
           if(key.toLowerCase()===replacingParent.replace(' ','_') || key.toLowerCase()===replacingParent){
             if(key.indexOf('image')!==-1){
               let imgUrl = API_URL+'files/download?fileId='+Data;
               if(isSet(attributes.isexternal,'false')==='true'){
                 imgUrl = Data;
               }
               element = React.createElement('img', {src:imgUrl,...attributes,style:{width:'100%',minWidth:'100px',maxWidth:'120px',overflow:'hidden'}})
             }else{
                // console.log('Data',Data,defaultValue);
               element = isSet(Data,isSet(defaultValue,''));
              //  console.log('formatVal',formatVal(attributes,element),element);
               element = formatVal(attributes,element);
             }
             
           }
         })
         fieldGroups.forEach((section) => {
           if(section.type!=='subform'){
                section.data.forEach((field)=>{
                   if(field.label.blocks[0].text.toLowerCase()===value.toLowerCase()){ 
                       element = isSet(getSelectedValueBasedOnField(field),isSet(defaultValue,''));
                       element = formatVal(attributes,element);
                   }
               }) 
           }
         });
      }
      const indexing = isSet(formFields,[]).findIndex((i=>i.label.toLowerCase()===attribsName.toLowerCase()));
      if(indexing!==-1){
        element = isSet(formFields,[])[indexing].value;
      }
     
  return isSet(element,defaultValue);  
}



